import {styled} from '@linaria/react';
import {gridContainer} from '../../../constants/gridSystem';
import {ROW_SECTION_MAX_WIDTH, RowSection} from '../SplitView/RowSection';

export {ROW_SECTION_MAX_WIDTH};

export const RowSectionGrid = styled(RowSection)`
  ${gridContainer};
  max-width: ${ROW_SECTION_MAX_WIDTH}px;
`;
